module.exports = __webpack_public_path__ + "static/assets/e3bb24700ae7a04d4e31b04ec67ce189.png";